import { Voter } from "@activecollab/security";
import { isFinancialManager, isPowerUser } from "~/utils/userHelper";

export class EstimateVoter extends Voter {
  attributes = ["create_project", "view_access_logs", "restore", "permanently_delete"];

  supports(attribute, subject) {
    if (!this.attributes.includes(attribute)) {
      return false;
    }
    return subject && subject.class === "Estimate";
  }

  voteOnAttribute(attribute, subject, user) {
    switch (attribute) {
      case "create_project": {
        if (isPowerUser(user)) {
          return subject.status !== "lost";
        }

        return false;
      }
      case "view_access_logs": {
        if (isFinancialManager(user)) {
          return true;
        }

        return false;
      }
      case "restore": {
        if (user.class === "Owner" || user.id === subject.trashed_by_id) {
          return true;
        }
        return false;
      }
      case "permanently_delete": {
        return user.class === "Owner";
      }
    }

    throw new Error("This code should not be reached!");
  }
}
